export default "__VITE_ASSET__305825ab__"